<template>
  <section :class="[{warningSection: showWarning}, style.phoneValidation]">
    <div class="phone-form-container">
      <div :class="['input-selector', {'saving': isSaving && !isLoading }]" v-if="!showWarning">
        <div :class="['selector', {'clickable': !isLoading && partner.mobileCountryPrefixSettings.mode !== 'one'}]"
            @click="openPhoneCountrySelector">
          <h5>{{chosenPrefix.prefix}}</h5>
          <span v-if="partner.mobileCountryPrefixSettings.mode !== 'one'" class="dropdown-arrow"></span>
        </div>
      </div>
      <one-line-form :submit="updatePhone" :submittable="isSubmittable" :saving="isSaving ? phone : ''" :button="!showWarning" :loading="isLoading">
        <template slot="underlay">
          <transition name="fade">
            <div class="input">
              <ins v-if="showWarning" :style="{fontSize : warningFontSize}">
                {{ phone }}
                <span>
                  {{ i18n.t('base:double_check') }}
                </span>
              </ins>
            </div>
          </transition>
        </template>
        <input-field name="phone"
                :class="{ invisible: isSaving, warning: showWarning }"
                :title="showWarning ? '' : i18n.t('phone:mobile_number')"
                :placeholder="i18n.t('phone:mobile_number')"
                :value="phone"
                v-mask="'111111111111111'"
                @input="syncPhone"
                @focus="editPhone"
                v-keyboard="'tel'"
                type="'tel'"
                :readonly="isLoading"
                ref='input'
                :autocomplete="'tel'" />
      </one-line-form>
    </div>
    <helper v-if="!isSaving && !showWarning && showElements">
      {{ partner.mobileCountryPrefixSettings.mode !== 'one' ? i18n.t('phone:enter_code_and_number') : i18n.t('phone:enter_mobile_number') }}
    </helper>
    <transition name="fade">
      <div class="warning-info" v-show="showWarning">
        <p>{{ i18n.t('phone:invalid') }}</p>
      </div>
    </transition>
    <transition name="bottom" appear>
      <action-bar v-if="showWarning && showElements">
        <ul>
          <li @click="editPhone" class="primary">
            <span>{{ i18n.t('base:edit') }}</span>
          </li>
        </ul>
      </action-bar>
    </transition>
    <phone-country-selector v-if="showPhoneCountrySelector"
                            @close="showPhoneCountrySelector = false"
                            :options="phoneCountryOptions"
                            @submit="pickCountryPrefix"
                            :subtitle-strong="true"
                            :is-overlay="true"></phone-country-selector>
    <show-keyboard v-if="!showWarning"></show-keyboard>
  </section>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/mixins';
  .phone-form-container {
    display: flex;
    width: 100%;
  }

  /deep/ form.has-submit {
    .overlay {
      padding-right: 30px;

      @include desktop {
        padding-right: 0;
      }
    }
  }
  .warningSection{
    margin-top: 120px !important;
  }
  ul {
    @include button-list;

    li{
      text-align: center;
      padding: 0;
    }
  }

  ins {
      color: transparent;
      background: #FFE676;
      display: inline-block;
      position: relative;

      span {
        background: no-repeat left 9px;
        background-image: url('~static/warning_pointer.svg');
        position: absolute;
        display: block;
        left: 40px;
        bottom: 100%;
        height: 40px;
        color: $inputWarningColor;
        color: $inputWarningColor-portal;
        font-size: 1rem;
        font-weight: lighter;
        padding-left: 42px;
        margin-bottom: 10px;
        line-height: 120%;
      }
    }

    .warning-info{
      position: absolute;
      width: 100%;
      left: 0;
      top: 75px;
      line-height: 20px;
    }

    .actions {
      z-index: 500;
      background: transparent;
    }

    .warning-info{
      font-family: $mainFontFamily;
      font-family: $mainFontFamily-portal;
      line-height: 25px;

      @media (max-width: #{$small-phone-width}) {
        line-height: 21px;
        bottom: 120px;
      }

      h3{
        font-family: $hintFontFamily;
        font-family: $hintFontFamily-portal;
        color: $inputRegularHeaderColor;
        color: $inputRegularHeaderColor-portal;
        font-size: $inputRegularHeaderSize;
        font-size: $inputRegularHeaderSize-portal;
        font-weight: $inputRegularHeaderWeight;
        font-weight: $inputRegularHeaderWeight-portal;
      }
      p{
        font-family: $hintFontFamily;
        font-family: $hintFontFamily-portal;
        color: $inputRegularBodyColor;
        color: $inputRegularBodyColor-portal;
        font-size: $inputRegularBodySize;
        font-size: $inputRegularBodySize-portal;
        font-weight: $inputRegularBodySize;
        font-weight: $inputRegularBodySize-portal;
      }
    }

    /deep/ .input-wrapper {
      label {
        margin-bottom: 0px;
      }
    }

    .input-selector {
      display: flex;
      align-items: center;
      height: 50px;
      .selector {
        min-width: 80px;
        height: 44px;
        display: flex;
        align-items: center;
        margin-right: 15px;
        justify-content: space-between;
        padding: 5px;
        box-sizing: border-box;
        border-radius: 5px;
        background-color: #FFFFFF;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.15);
        &.clickable {
          cursor: pointer;
        }
        h5 {
          flex: 1;
          text-align: center;
          font-weight: $boldFontWeight;
          font-size: 1.25rem;
          color: $inputActiveColor;
          color: $inputActiveColor-portal;
          margin-right: 5px;
          font-family: inherit;
        }
        .dropdown-arrow {
          position: relative;
          width: 13px;
          height: 20px;
          &:before {
            content: '';
            position: absolute;
            top: 10px;
            right: 0;
            margin: 0 auto;
            width: 8px;
            height: 2px;
            border-radius: 2px;
            background-color: #D6D6D6;
            transform: rotate(-45deg);
          }

          &:after {
            content: '';
            position: absolute;
            top: 10px;
            left: 0;
            margin: 0 auto;
            height: 2px;
            width: 8px;
            border-radius: 2px;
            background-color: #D6D6D6;
            transform: rotate(45deg);
          }
        }
      }

      &.saving {
        .selector {
          box-shadow: none;
          min-width: initial;
          margin-right: 0;
          .dropdown-arrow {
            display: none;
          }
          h5 {
            font-size: 1.625rem;
            color: $inputSaveColor;          
          }
        }
      }
    }

</style>

<script>
  import Vue from 'vue'
  import { mapState, mapMutations } from 'vuex'
  import Screen from '../components/Screen'
  import OptionSelector from '../components/OptionSelector'

  const libphonenumber = () => import('../utils/libphonenumberProxy')

  export default Vue.component('phone-screen', {
    
    components: {
      'screen': Screen,
      'phone-country-selector': OptionSelector
    },
    props: ['screenParams'],
    data () {
      const user = this.$store.state.user
      const autofill = this.$store.state.autofill

      return {
        phone: user.phoneWithoutPrefix || user.phone || (autofill.enabled && autofill.phone) || '',
        maskedPhone: '',
        isSaving: false,
        showWarning: false,
        showPhoneCountryCodeSelector: false,
        showPhoneCountrySelector: false,
        showElements: false,
        screenType: '',
        isValid: false,
        ready: false,
        fromVerificationCode: this.$store.state.route.from.fullPath.includes('sms-code'),
        chosenPrefix: {
          country: '',
          prefix: ''
        },
        isLoading: false,
        warningFontSize: null
      }
    },
    watch: {
      showWarning () {
        if (this.showWarning && document.activeElement.nodeName.toLowerCase() === 'input') {
          document.activeElement.blur()
        }

        this.screenType = this.showWarning ? 'error' : ''
  
        const input = this.$el.querySelector('input')
        if (input) {
          this.warningFontSize = input.style.fontSize
        }
      },
      isSubmittable () {
        this.refreshToolTip()
      },
      showPhoneCountrySelector () {
        if (this.showPhoneCountrySelector) {
          this.$emit('tooltip', ['vertical', 'enter'])
        } else {
          this.refreshToolTip()
        }
      },
      isSaving () {
        if (this.isSaving) {
          this.$emit('tooltip', 'hide')
        }
      }
    },
    computed: {
      ...mapState(['partner', 'l10n', 'app', 'user', 'route', 'routingInfo', 'phonePrevalidation']),
      style () {
        return {
          phoneValidation: this.$css(`

            ins {
              span {
                color: ${this.theme.inputWarningColor} !important;
              }
            }
            .warning-info{
              font-family: ${this.theme.mainFontFamily} !important;

              h3{
                font-family: ${this.theme.mainFontFamily} !important;
                color: ${this.theme.inputRegularHeaderColor} !important;
                font-size: ${this.theme.inputRegularHeaderSize} !important;
                font-weight: ${this.theme.inputRegularHeaderWeight} !important;
              }
              p{
                font-family: ${this.theme.mainFontFamily} !important;
                color: ${this.theme.inputRegularBodyColor} !important;
                font-size: ${this.theme.inputRegularBodySize} !important;
                font-weight: ${this.theme.inputRegularBodySize} !important;
              }
            }

            .input-selector {
              .selector {
                h5 {
                  font-weight: ${this.theme.boldFontWeight} !important;
                  color: ${this.theme.inputActiveColor} !important;
                }
              }
              &.saving {
                .selector {
                  h5 {
                    color: ${this.theme.inputSaveColor} !important;          
                  }
                }
              }
            }
          `)
        }
      },
      isSubmittable () {
        const numbers = this.phone && this.phone.match(/\d/g)
        return !!numbers && numbers.length >= 5
      },

      phoneCountryOptions () {
        let countriesData = this.$store.state.phoneCountryOptions.map(country => ({
          label: this.getLocalCountryName(country.countryCode, this.i18n),
          subtitle: country.countryPrefix,
          countryPrefix: country.countryPrefix,
          countryCode: country.countryCode
        }))
        return countriesData.sort((a, b) => a.label.localeCompare(b.label))
      }
    },
    methods: {
      ...mapMutations(['updateUser', 'updatePhonePrevalidation']),
      openPhoneCountrySelector () {
        if (this.isLoading || this.isSaving || this.partner.mobileCountryPrefixSettings.mode === 'one') return
        this.showPhoneCountrySelector = true
      },
      async pickCountryPrefix ({countryCode, countryPrefix}) {
        this.showPhoneCountrySelector = false
        this.chosenPrefix = {
          country: countryCode,
          prefix: countryPrefix
        }
      },
      syncPhone (value, maskedValue) {
        if (this.usingPrefill && value !== this.phone) this.usingPrefill = false
        this.phone = value
        this.maskedPhone = maskedValue
      },
      async updatePhone () {
        this.isLoading = true
        this.isSaving = true
        const phone = await this.processPhone()
        await this.sleep(1000)
        this.isLoading = false
        if (!phone) {
          this.showWarning = true
          this.isSaving = false
          this.updatePhonePrevalidation({
            isValid: false
          })
          return
        }

        this.updateUser(phone)
        this.trackPrefill('phone', this.phone)

        await this.sleep(500)
        this.updatePhonePrevalidation({
          country: this.chosenPrefix.country,
          isValid: true
        })
  
        if (this.user.phoneVerificationAttempts) {
          this.user.phoneVerificationAttempts = 1
        }

        if (this.fromVerificationCode) {
          return this.$store.dispatch('replace', this.route.from.fullPath)
        }
        return this.$store.dispatch('next', this.screenParams.nextScreenRoute)
      },
      async sleep (t) {
        return new Promise(resolve => setTimeout(resolve, t))
      },
      editPhone () {
        if (this.ready) {
          this.showWarning = false
          this.showPhoneCountryCodeSelector = true
          // using double '$refs' because input is nested in another component
          this.$refs.input.$refs.input.focus()
        }
      },
      processPhone () {
        return libphonenumber().then(libphonenumberMethods => {
          if (/^0+/.test(this.phone)) this.phone = this.phone.replace(/^0+/, '')

          const prefixedPhone = this.chosenPrefix.prefix + this.phone
          const cleanParse = libphonenumberMethods.parse(prefixedPhone)
          if (cleanParse.phone && cleanParse.country && libphonenumberMethods.isValidNumber(cleanParse)) {
            const phoneE164 = libphonenumberMethods.format(cleanParse.phone, cleanParse.country, 'E.164')
            const phone = {
              phone: libphonenumberMethods.format(prefixedPhone, 'National').replace(/\D/g, ''),
              phoneE164: phoneE164.replace('+', ''),
              phoneWithoutPrefix: phoneE164.replace(this.chosenPrefix.prefix, ''),
              phonePrefix: this.chosenPrefix.prefix,
              phoneCountry: libphonenumberMethods.parse(phoneE164).country
            }
            return phone
          }
          return false
        })
      },
      refreshToolTip () {
        if (!this.showWarning) {
          this.$emit('tooltip', this.isSubmittable ? ['enter'] : ['type'])
        }
      }
    },
    beforeCreate () {
      libphonenumber()
    },
    created () {
      if (!this.phonePrevalidation.isValid) this.showWarning = true
      const currentCountry = this.phoneCountryOptions.find(country => country.countryCode === (this.user.country || this.app.country.code)) ||
        this.phoneCountryOptions[0]

      this.chosenPrefix = {
        country: this.user.country || this.app.country.code,
        prefix: this.user.phonePrefix || currentCountry.countryPrefix
      }
    },
    mounted () {
      setTimeout(() => {
        this.showElements = true
        this.ready = true
        if (this.showWarning && document.activeElement.nodeName.toLowerCase() === 'input') {
          document.activeElement.blur()
        }
        if (this.showWarning) {
          this.$emit('tooltip', ['enter'])
        } else {
          this.$emit('tooltip', ['type'])
        }
      }, 100)
    }
  })
</script>



// WEBPACK FOOTER //
// src/screens/PhoneNumberValidation.vue